export class PageData {

  public totalPages: number;

  constructor(
    public totalElements: number,
    public pageSize: number
  ) {
    this.totalPages = Math.ceil(this.totalElements / this.pageSize);
  }
}
